export const ENVIRONMENTS = {
  APP: {
    BASEURL: process.env.REACT_APP_BASE_URL,
    TYPE_AI_FRONTEND_URL: process.env.REACT_APP_TYPE_AI_FRONTEND_URL
  }
};
